import { Component, Input } from "@angular/core";

import type { DriveViewerPresentationFacade } from './drive-viewer.presentation-facade';

type DriveContentViewPort = Pick<DriveViewerPresentationFacade,
  'breadcrumbClick' | 'closeContextMenu' | 'currentFolderTotalCount' | 'currentPath' | 'displayName'
  | 'dragHoverFolderId' | 'dropListId' | 'folderDropListIds' | 'getFileTypeLabel'
  | 'getItemIcon' | 'getItemIconClass' | 'hasActiveFilters' | 'isFolderDropCandidate' | 'isLoadingFiles'
  | 'isVirtualFolderId' | 'navigateTo' | 'onContentContextMenu' | 'onContentRowContextMenu'
  | 'onDropOnFolder' | 'onFileDragEnded' | 'onFileDragStarted' | 'onFolderDragEntered'
  | 'onFolderDragExited' | 'onItemNameClick' | 'onNativeDropOnFolder'
  | 'onNativeFileDragEnded' | 'onNativeFileDragStarted' | 'onNativeFolderDragLeave'
  | 'onNativeFolderDragOver' | 'onSortDirChange' | 'onSortKeyChange' | 'openPreview'
  | 'selectedIds' | 'selectionCount' | 'selectionSizeBytes' | 'showVersionBadge'
  | 'sortDir' | 'sortKey' | 'sourceDropListIds'
  | 'toggleSelect' | 'trackById' | 'translate' | 'versionBadges' | 'view' | 'visibleItems'>;

@Component({
  selector: "app-drive-viewer-content",
  templateUrl: "./drive-viewer-content.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class DriveViewerContentComponent {
  @Input({ required: true }) view!: DriveContentViewPort;

  focusSiblingRow(event: Event, direction: 1 | -1): void {
    event.preventDefault();
    const row = event.currentTarget as HTMLElement | null;
    if (!row) return;
    const container = row.closest('tbody, .grid, .mobile-file-list');
    if (!container) return;
    const rows = Array.from(container.querySelectorAll<HTMLElement>('[tabindex]'));
    const index = rows.indexOf(row);
    rows[index + direction]?.focus();
  }
}
